/**
 * Tenant socket rooms to join/leave so the socket holds exactly the wanted set. Without leaves a
 * socket keeps every tenant room it ever joined (stale fan-out; for a global admin, every context
 * workspace visited stays subscribed and audited). Pure (node --test).
 */
export function roomChanges(joined: ReadonlySet<string>, wanted: string[]): { join: string[]; leave: string[] } {
  const want = new Set(wanted);
  return {
    join: [...want].filter((id) => !joined.has(id)),
    leave: [...joined].filter((id) => !want.has(id)),
  };
}
